import Vue from "vue";
import Router from "vue-router";
import Login from "@/pages/login/index";
import kuaixunphone from "@/pages/message/addmessage/phone";
import Layout from "@/pages/layout/layout";
import permission from "../store/modules/permission";
Vue.use(Router);

export default new Router({
	routes: [
		{
			path: "/",
			redirect: "/index",
			hidden: true,
			children: [],
			meta: { permission: 0 },
		},
		{
			path: "/login",
			component: Login,
			name: "",
			children: [],
			meta: { permission: 0 },
		},
		{
			path: "/kuaixunphone",
			component: kuaixunphone,
			name: "",
			children: [],
			meta: { permission: 0 },
		},
		{
			path: "/",
			name: "layout",
			component: Layout,
			children: [
				{
					path: "index",
					name: "主页",
					component: () => import("@/pages/home/home.vue"),
					meta: { permission: 100 },
				},
				{
					path: "user",
					name: "用户管理",
					component: () => import("@/pages/user/index.vue"),
					meta: { permission: 800 },
					children: [
						{
							path: "userlist",
							name: "用户列表",
							component: () => import("@/pages/user/userlist/index.vue"),
							meta: { permission: 801 },
						},
						{
							path: "adduser",
							name: "新增用户",
							component: () => import("@/pages/user/adduser/index.vue"),
							meta: { permission: 802 },
						},
						{
							path: "config",
							name: "配置管理",
							component: () => import("@/pages/user/config/index.vue"),
							meta: { permission: 804 },
						},
						{
							path: "examinelist",
							name: "认证审核",
							component: () => import("@/pages/user/examinelist/index.vue"),
							meta: { permission: 805 },
						},
					],
				},
				{
					path: "addpersonal",
					name: "个人用户新增",
					component: () => import("@/pages/user/adduser/addpersonal.vue"),
					meta: { permission: 806 },
				},
				{
					path: "addfirm",
					name: "企业用户新增",
					component: () => import("@/pages/user/adduser/addfirm.vue"),
					meta: { permission: 807 },
				},
				{
					path: "message",
					name: "资讯管理",
					component: () => import("@/pages/message/index.vue"),
					meta: { permission: 300 },
					children: [
						{
							path: "messagelist",
							name: "资讯列表",
							component: () => import("@/pages/message/messagelist/index.vue"),
							meta: { permission: 301 },
						},
						{
							path: "thirdmessage",
							name: "三方快讯",
							component: () =>
								import("@/pages/message/messagelist/thirdmessage.vue"),
							meta: { permission: 301 },
						},
						{
							path: "addmessage",
							name: "新增资讯",
							component: () => import("@/pages/message/addmessage/index.vue"),
							meta: { permission: 302 },
						},
						{
							path: "addmessage_new",
							name: "新增资讯新",
							component: () =>
								import("@/pages/message/addmessage/index_new.vue"),
							meta: { permission: 302 },
						},
						{
							path: "flashpc",
							name: "快讯模版",
							component: () => import("@/pages/message/addmessage/phone.vue"),
							meta: { permission: 303 },
						},
						{
							path: "dellist",
							name: "恢复数据",
							component: () => import("@/pages/message/dellist/index.vue"),
							meta: { permission: 304 },
						},
						{
							path: "category",
							name: "类别管理",
							component: () => import("@/pages/message/category/index.vue"),
							meta: { permission: 305 },
						},
						{
							path: "special",
							name: "专区管理",
							component: () => import("@/pages/message/special/index.vue"),
							meta: { permission: 306 },
						},
						{
							path: "label",
							name: "专题管理",
							component: () => import("@/pages/message/label/index.vue"),
							meta: { permission: 307 },
						},
						{
							path: "tools",
							name: "工具管理",
							component: () => import("@/pages/message/tools/index.vue"),
							meta: { permission: 308 },
						},
						{
							path: "addtools",
							name: "新增工具",
							component: () => import("@/pages/message/tools/addtools.vue"),
							meta: { permission: 309 },
						},
						{
							path: "addLabel",
							name: "新增专题",
							component: () => import("@/pages/message/label/addLabel.vue"),
							meta: { permission: 310 },
						},
						{
							path: "messageexamine",
							name: "审核管理",
							component: () =>
								import("@/pages/examine/messageexamine/index.vue"),
							meta: { permission: 311 },
						},
						{
							path: "aitopic",
							name: "AI专题",
							component: () => import("@/pages/message/aitopic/index.vue"),
							meta: { permission: 311 },
						},
						{
							path: "aitopicdetail",
							name: "专题详情",
							component: () => import("@/pages/message/aitopic/detail.vue"),
							meta: { permission: 311 },
						},
					],
				},
				,
				{
					path: "event",
					name: "活动管理板块",
					component: () => import("@/pages/event/index.vue"),
					meta: { permission: 400 },
					children: [
						{
							path: "events",
							name: "活动管理",
							component: () => import("@/pages/event/events/index.vue"),
							meta: { permission: 401 },
						},

						{
							path: "order",
							name: "订单管理",
							component: () => import("@/pages/event/order/index.vue"),
							meta: { permission: 402 },
						},
						{
							path: "addevent",
							name: "新增活动",
							component: () => import("@/pages/event/events/addEventV2.vue"),
							meta: { permission: 403 },
						},
						{
							path: "legacy-addevent",
							name: "旧版新增活动",
							hidden: true,
							component: () => import("@/pages/event/events/addEvent.vue"),
							meta: { permission: 403, hidden: true },
						},
						{
							path: "sideEvent",
							name: "旧版SIDE活动",
							component: () => import("@/pages/event/sideEvent/index.vue"),
							meta: { permission: 404 },
						},
						{
							path: "collections",
							name: "活动合集管理",
							component: () => import("@/pages/event/collections/index.vue"),
							meta: { permission: 404 },
						},
						{
							path: "collectionEdit",
							name: "新增编辑活动合集",
							component: () => import("@/pages/event/collections/edit.vue"),
							meta: { permission: 404 },
						},
						{
							path: "sideIndex",
							name: "side详情",
							component: () => import("@/pages/event/sideEvent/sideIndex.vue"),
							meta: { permission: 405 },
						},
						{
							path: "otherSideIndex",
							name: "otherSide详情",
							component: () =>
								import("@/pages/event/sideEvent/otherSideIndex.vue"),
							meta: { permission: 406 },
						},
					],
				},
				{
					path: "recommend",
					name: "推荐配置",
					component: () => import("@/pages/recommend/index.vue"),
					meta: { permission: 600 },
					children: [
						{
							path: "bannerlist",
							name: "推荐Banner管理",
							component: () => import("@/pages/recommend/banner/index.vue"),
							meta: { permission: 601 },
						},
						{
							path: "bannerdetail",
							name: "Banner详情",
							component: () =>
								import("@/pages/recommend/banner/bannerdetail.vue"),
							meta: { permission: 602 },
						},
						{
							path: "eventtop",
							name: "活动置顶管理",
							component: () => import("@/pages/recommend/eventtop/index.vue"),
							meta: { permission: 603 },
						},
						{
							path: "amalist",
							name: "AMA管理",
							component: () => import("@/pages/recommend/banner/amaIndex.vue"),
							meta: { permission: 603 },
						},
						{
							path: "homeClicklist",
							name: "首页金刚位管理",
							component: () =>
								import("@/pages/recommend/banner/homeClickIndex.vue"),
							meta: { permission: 603 },
						},
					],
				},
				{
					path: "dataera",
					name: "DataEra",
					component: () => import("@/pages/dataera/index.vue"),
					meta: { permission: 500 },
					children: [
						{
							path: "dataera_btc",
							name: "BTC持币机构",
							component: () => import("@/pages/dataera/btc/index.vue"),
							meta: { permission: 501 },
						},
					],
				},
				{
					path: "information",
					name: "消息管理",
					component: () => import("@/pages/information/index.vue"),
					meta: { permission: 700 },
					children: [
						{
							path: "push",
							name: "推送信息",
							component: () => import("@/pages/information/push/index.vue"),
							meta: { permission: 701 },
						},
						{
							path: "problemfeedback",
							name: "问题反馈",
							component: () =>
								import("@/pages/information/problemfeedback/index.vue"),
							meta: { permission: 702 },
						},
						{
							path: "reportinfo",
							name: "举报信息",
							component: () =>
								import("@/pages/information/reportinfo/index.vue"),
							meta: { permission: 703 },
						},
						{
							path: "addPush",
							name: "新增APP推送信息",
							component: () =>
								import("@/pages/information/push/addPush/index.vue"),
							meta: { permission: 704 },
						},
						{
							path: "telegram",
							name: "Telegram推送",
							component: () => import("@/pages/information/telegram/index.vue"),
							meta: { permission: 705 },
						},
						{
							path: "botArticleDetail",
							name: "新增Bot",
							component: () =>
								import("@/pages/information/telegram/articledetail.vue"),
							meta: { permission: 706 },
						},
						{
							path: "botEventDetail",
							name: "Bot详情",
							component: () =>
								import("@/pages/information/telegram/eventdetail.vue"),
							meta: { permission: 707 },
						},
					],
				},
				{
					path: "limitsauthority",
					name: "权限管理",
					component: () => import("@/pages/limitsauthority/index.vue"),
					meta: { permission: 900 },
					children: [
						{
							path: "personnel",
							name: "人员管理",
							component: () =>
								import("@/pages/limitsauthority/personnel/index.vue"),
							meta: { permission: 901 },
						},
						{
							path: "addpersonnel",
							name: "新增管理人员",
							component: () =>
								import("@/pages/limitsauthority/addpersonnel/index.vue"),
							meta: { permission: 902 },
						},
						{
							path: "role",
							name: "角色管理",
							component: () => import("@/pages/limitsauthority/role/index.vue"),
							meta: { permission: 903 },
						},
						{
							path: "addrole",
							name: "新增角色",
							component: () =>
								import("@/pages/limitsauthority/addrole/index.vue"),
							meta: { permission: 904 },
						},
						{
							path: "info",
							name: "人员信息详情",
							component: () =>
								import("@/pages/limitsauthority/addpersonnel/info.vue"),
							meta: { permission: 905 },
						},
					],
				},
				{
					path: "webdata",
					name: "运营数据",
					component: () => import("@/pages/webdata/index.vue"),
					meta: { permission: 200 },
					children: [
						{
							path: "pvuv",
							name: "全站数据",
							component: () => import("@/pages/webdata/pvuv/index.vue"),
							meta: { permission: 201 },
						},
						{
							path: "messageList",
							name: "文章列表",
							component: () => import("@/pages/webdata/messagelist/index.vue"),
							meta: { permission: 202 },
						},
						{
							path: "singleList",
							name: "单篇数据",
							component: () => import("@/pages/webdata/singleList/index.vue"),
							meta: { permission: 203 },
						},
						{
							path: "dailyDetail",
							name: "每日明细",
							component: () => import("@/pages/webdata/dailyDetail/index.vue"),
							meta: { permission: 201 },
						},
						{
							path: "overview",
							name: "overview",
							component: () => import("@/pages/webdata/overview/index.vue"),
							meta: { permission: 204 },
						},
						{
							path: "zloverview",
							name: "zloverview",
							component: () => import("@/pages/webdata/zloverview/index.vue"),
							meta: { permission: 204 },
						},
						{
							path: "aioverview",
							name: "aioverview",
							component: () => import("@/pages/webdata/aioverview/index.vue"),
							meta: { permission: 204 },
						},
						{
							path: "articleCount",
							name: "articleCount",
							component: () => import("@/pages/webdata/articleCount/index.vue"),
							meta: { permission: 204 },
						},
					],
				},
				{
					path: "laboratory",
					name: "科学实验室",
					component: () => import("@/pages/laboratory/index.vue"),
					meta: { permission: 1000 },
					children: [
						{
							path: "editor",
							name: "编辑器",
							component: () => import("@/pages/laboratory/editor/index.vue"),
							meta: { permission: 1001 },
						},
					],
				},
				{
					path: "prediction",
					name: "预测市场",
					component: () => import("@/pages/prediction/index.vue"),
					meta: { permission: 1100 },
					children: [
						{
							path: "",
							name: "预测事件列表",
							component: () => import("@/pages/prediction/eventlist/index.vue"),
							meta: { permission: 1101 },
						},
					],
				},
				{
					path: "appVersion",
					name: "下载提示配置",
					component: () => import("@/pages/appVersion/index.vue"),
					meta: { permission: 1200 },
				},
			],
		},
	],
});
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};
